export const meta = {
  appAlias: 'store-locator',
  appName: 'Store Locator'
} as const;
